// extracted by mini-css-extract-plugin
export default {"env-box":"CurEnvList_env-box__0yPCS"};